import type { LicenseDTO } from '@shared/dto/config';

import { callApiJson } from '../api';

export const fetchLicense = async (): Promise<LicenseDTO> => {
  return await callApiJson('/license', {}, { skip401Redirect: true });
};
